export default __webpack_public_path__ + "static/media/GoalImg16.a5897a88.png";